export default "__VITE_ASSET__2vlME2N5__"